import { COUNTRY_DIALLING_CODES_DATA } from "./countryDiallingCodesData.ts";

/**
 * The country dialling codes data provided by pega does not contain enough information at present.
 * So the front end inject some extra data here
 */
export const injectCountryDiallingCodeData = (
  countryOptions: { value: string }[],
) => {
  let countryDiallingCodesClone = COUNTRY_DIALLING_CODES_DATA.map((data) => {
    return { ...data };
  });

  return countryOptions
    .map((option) => {
      const foundDiallingCode = countryDiallingCodesClone.find((data) => {
        return data.diallingCode === option.value;
      });

      // Remove the entry we found so it cant be used again
      // This is to handle multiple entries for the same dialling code ie Jersey, Guernsey, United Kingdom are all +44
      // So we need to make sure we display an entry for each
      countryDiallingCodesClone = countryDiallingCodesClone.filter(
        (data) => data !== foundDiallingCode,
      );

      return {
        ...option,
        label: foundDiallingCode?.label || "",
        countryCode: foundDiallingCode?.countryCode || "",
      };
    })
    .sort((a: { label: string }, b: { label: string }): number => {
      // we can't work out this first country dynamically because there are multiple entries for +44
      const firstCountryLabel =
        countryOptions[0].value === "+44" ? "United Kingdom (+44)" : undefined;

      if (a.label === firstCountryLabel) return -1; // a goes first
      if (b.label === firstCountryLabel) return 1; // b goes first

      // Otherwise sort alphabetically
      return a.label.localeCompare(b.label);
    });
};
